// const state = {
//     notification: [],
//     justremoved: false
// };
//
// const getters = {
//     notification: (state) => state.notification
// };
//
// const mutations = {
//     notification: (state, payload) => {
//         state.notification = payload;
//     }
// };
//
// const actions = {
//     notification: ({commit, state}, payload) => {
//
//         if(state.justremoved && state.notification.length == 1){
//             state.notification.push(payload);
//             state.notification.shift();
//         }
//         else{
//             state.notification.push(payload);
//         }
//         state.justremoved = false;
//
//         console.log(state.notification);
//
//     },
//     clearNotification: ({state}, payload) =>{
//
//          if(state.notification.length > 1){
//             state.notification.shift();
//         }
//         state.justremoved = true;
//     }
// };
//
// export default {
//     namespaced: true,
//     state,
//     getters,
//     mutations,
//     actions
// }

// ============================================================

const state = {
    notifications: [],
    current: null
};

const getters = {
    notifications: state => state.notifications,
    current: state => state.current
};

const mutations = {
    add: (state, payload) => {
        state.notifications = state.notifications.concat(payload);
    },
    remove: (state, payload) => {
        state.notifications = state.notifications.filter(n => n.id !== payload.id);
    },
    current: (state, payload) => {
        state.current = payload;
    }
};

const actions = {

    notification: ({ dispatch }, payload) => {
        dispatch('add', payload);
    },

    add: ({ commit, dispatch }, payload) => {
        commit('add', payload);
        dispatch('current');
        console.log(payload);
    },

    remove: ({ commit, dispatch }, payload) => {
        commit('remove', payload);
        dispatch('current');
    },

    current: ({ state, commit }) => {
        if (state.notifications.length > 0) {
            commit('current', state.notifications[0]);
        } else {
            commit('current', null);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
